/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...postConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        window.gwp.EventBus.emit('AjaxCart:updated', parsedState);
        
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);


const updateNibbleButton = (showBar) => {
  let nibbleButton = document.querySelector("#fc_frame")
          
  if(nibbleButton){
    if(showBar){
      nibbleButton.classList.add("fc_frame-offset--cart")
    }else{
      nibbleButton.classList.remove("fc_frame-offset--cart")
    }
  }else{
    setTimeout(updateNibbleButton(), 3000)
  }
}
// Check for nibble for certain amount of time to offset it when it loads in
let elapsedCheckForNibble = 0
let elapsedCheckForNibbleMax = 10 * 1000
let elapsedCheckForNibbleDelay = 500
const checkForNibble = () => {
  if(elapsedCheckForNibble >= elapsedCheckForNibbleMax) return;
  let nibbleButton = document.querySelector("#fc_frame--cart")
  if (nibbleButton) {
    nibbleButton.classList.add("fc_frame-offset--cart")
    
    return;
  }
  
  setTimeout( checkForNibble, elapsedCheckForNibbleDelay );
  elapsedCheckForNibble += elapsedCheckForNibbleDelay;
}

console.log("hupi - start")
window.when('.js-cart-atc-bar', () => {
  checkForNibble()

  const el = document.querySelector('.js-cart-atc-bar');
  const trigger = document.querySelector('.js-cart-atc-bar-trigger');
  if(!el) return;
  const btn = el.querySelector('.js-btn');
  const target = document.querySelector('.js-cart-atc-bar-target');

  btn.addEventListener('click', (e) => {
    target.scrollIntoView({behavior: 'smooth', block: 'center'});
    e.preventDefault();
  });

  if (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  ) {
    const observer = new IntersectionObserver((entries) => {
      let rect = entries[0].boundingClientRect
      let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      // const showBar = (entries[0].boundingClientRect.y < 0);
      let showBar = (rect.bottom < 0 || rect.top - viewHeight >= 0);

      el.classList.toggle('is-visible', showBar);
  
      el.classList.toggle('is-visible', showBar);

      updateNibbleButton(showBar);
    }, {
      threshold: 1.0,
      root: null,
    });

    observer.observe(trigger);
  }
});
